import { HeaderComponent } from './../../giveback/header/header.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { CommercialService } from '../questionnaire/commercial.service';
import { _ } from 'underscore';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.css'],
})
export class CommonHeaderComponent implements OnInit {
  iconshow = true;
  menuIconShow = true;
  modalVisible = false;
  accountId;
  deviceWidth;
  url = environment.api_url;
  aap_url = environment.aap_url;
  showLogin = true;
  constructor(
    private router: Router,
    private residentialService: ResidentialService,
    private commercialService: CommercialService
  ) {}

  gotologout() {
    sessionStorage.clear();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  ngOnInit() {
    if (window.location.href.indexOf('commercial/congrats') > -1) {
      this.iconshow = false;
    }
    const user = sessionStorage.getItem('userObj');
    if(user)
    {
      this.showLogin = false;
    }
  }
  headerMenu(selectedMenu) {
    if (selectedMenu === 'home') {
      this.router.navigateByUrl('/commercial');
    } else if (selectedMenu === 'faq') {
      this.router.navigateByUrl('/faq');
    } else if (selectedMenu === 'giveback') {
      this.router.navigateByUrl('/giveback');
    } else if (selectedMenu === 'startover') {
      this.startOver();
    } else if (selectedMenu === 'precontact') {
      this.router.navigateByUrl('/faq/contact-us');
    } else if (selectedMenu === 'blog') {
      this.router.navigateByUrl('/blog');
    }
  }

  gotoProfile() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.hg_accountId) {
        this.router.navigate(['user-settings', result.hg_accountId]);
      } else {
        this.router.navigate(['user-settings', result._id]);
      }
    }
  }

  // This function is called when the "list icon" click
  openNav(event) {
    if (
      event.toElement &&
      event.toElement.classList.contains('logotextClick')
    ) {
      this.router.navigateByUrl('/commercial');
    } else {
      // // console.log.log(event.toElement);
      const elemntObjt = document.getElementById('hideprocess');
      const hidetext = document.getElementById('hidetxt');
      elemntObjt.classList.add('buttonhide');
      hidetext.classList.add('buttonhide');
      const collapse = document.getElementById('mySidebar');
      collapse.classList.add('sidemenu');
      document.getElementById('mySidebar').style.width = '250px';
      document.getElementById('main').style.marginLeft = '250px';
    }
  }

  // This function is called when the "close icon" click
  closeNav() {
    const elemntObjt = document.getElementById('hideprocess');
    const hidetext = document.getElementById('hidetxt');
    if (elemntObjt !== null && elemntObjt.classList.contains('buttonhide')) {
      elemntObjt.classList.remove('buttonhide');
    }
    if (hidetext !== null && hidetext.classList.contains('buttonhide')) {
      hidetext.classList.remove('buttonhide');
    }
    const collapse = document.getElementById('mySidebar');
    collapse.classList.remove('sidemenu');
    document.getElementById('mySidebar').style.width = '0';
    document.getElementById('main').style.marginLeft = '0';
  }
  onClose(isVisible: boolean) {
    this.modalVisible = isVisible;
  }
  showModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.modalVisible = true;
  }
  startOver() {
    sessionStorage.clear();
    this.commercialService.addAddress = false;
    this.commercialService.serialNumber = null;
    this.commercialService.messageService({});
    this.commercialService.userResponse.userResponses = [];
    // this.commercialService.isStartOver = true;
    this.router.navigateByUrl('/commercial/questionnaire');
  }
}
